import { sorters } from "../functions";

const strategies = {
  title: sorters.title,
  createdDate: sorters.createdDate,
  createddate: sorters.createdDate,
  lastLoggedIn: sorters.lastLoggedIn,
  lastloggedin: sorters.lastLoggedIn,
  date: (a, b) => new Date(b.date) - new Date(a.date),
};

const sort = (items, sortBy) => {
  if (!Array.isArray(items)) {
    return [];
  }
  const sorter = strategies[sortBy?.toLowerCase()] || strategies.title;
  const sortedItems = sorter(items);
  return sortedItems;
};

const getFilteredItemsByType = (items, filterType) => {
  return items[filterType] || items.all || [];
};

const getSortedItems = (items, sorter) => {
  return Array.isArray(items) ? sorter(items) : [];
};

const updateList = (items, filter, filterType) => {
  if (!items) {
    return { active: [] };
  }

  const sortBy = filter?.sortBy?.toLowerCase() || "";
  const sorter = strategies[sortBy] || strategies.title;

  const filteredItems = getFilteredItemsByType(items, filterType);
  const sortedItems = getSortedItems(filteredItems, sorter);

  return {
    ...items,
    active: sortedItems,
  };
};

export const sortService = {
  sort,
  updateList,
};
